import { Button } from '@fluentui/react-components';
import { ArrowBidirectionalUpDown20Regular, ArrowSortDown20Filled, ArrowSortUp20Filled } from '@fluentui/react-icons';
import { HeaderContext, SortDirection } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { GetFolderPermissionsEwsPermissionInfo } from '../../../../api/types.gen';

interface IHeaderCellProps {
  headerContext: HeaderContext<GetFolderPermissionsEwsPermissionInfo | null, unknown>;
}

export function HeaderCell({ headerContext }: IHeaderCellProps) {
  const { t } = useTranslation('', { keyPrefix: 'permissions' });
  const { column } = headerContext;
  const sortDirection = column.getIsSorted();

  let sortLabel = t('unsortedLabel');
  if (sortDirection === 'asc') {
    sortLabel = t('sortAscLabel');
  }

  if (sortDirection === 'desc') {
    sortLabel = t('sortDescLabel');
  }

  return (
    <Button
      onClick={column.getToggleSortingHandler()}
      appearance="transparent"
      style={{
        whiteSpace: 'nowrap',
        padding: 0,
        justifyContent: 'space-between',
        gap: 4,
      }}
      aria-label={sortLabel}
    >
      {t(headerContext.column.id)}
      <SortIcon sortDirection={sortDirection} />
    </Button>
  );
}

interface ISortProps {
  sortDirection: false | SortDirection;
}

function SortIcon({ sortDirection }: ISortProps) {
  if (sortDirection === 'asc') {
    return <ArrowSortUp20Filled />;
  }

  if (sortDirection === 'desc') {
    return <ArrowSortDown20Filled />;
  }

  return <ArrowBidirectionalUpDown20Regular />;
}
